import { render } from "./ArrangeCsv.vue?vue&type=template&id=b906cd6a&scoped=true"
import script from "./ArrangeCsv.vue?vue&type=script&lang=js"
export * from "./ArrangeCsv.vue?vue&type=script&lang=js"

import "./ArrangeCsv.vue?vue&type=style&index=0&id=b906cd6a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b906cd6a"]])

export default __exports__